import React from 'react';
import { connect } from 'react-redux';
import { getFundraisingPagesData } from '../../selectors/apiSelectors';
import LinkFundraisingPage from '../LinkFundraisingPage/LinkFundraisingPage';
import UnableToJoin from '../../components/UnableToJoin/UnableToJoin';
import { IAppState } from '../../types/state.d';

type ConnectFRPWrapperProps = {
  fundraisingPages: IAppState['api']['fundraisingPagesData'];
};

export const ConnectFRPWrapper = ({
  fundraisingPages,
}: ConnectFRPWrapperProps) =>
  fundraisingPages.length ? <LinkFundraisingPage /> : <UnableToJoin />;

const mapStateToProps = (state: IAppState) => ({
  fundraisingPages: getFundraisingPagesData(state),
});

export default connect(mapStateToProps)(ConnectFRPWrapper);
